'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Page() {
  const router = useRouter();
  useEffect(() => { router.replace('/lp/ar/customer-experience-platform-middle-east'); }, [router]);
  return null;
}
